<template>
  <v-container class="text-center">
    <v-layout row justify-space-around>
      <v-flex xs8 sm6 md4 lg3 xl2 class="text-xs-center">
        <v-card outlined class="pa-5 text-center">
          <p class="title orange--text">Welcome to Omentum</p>
          <p>
            To get started, please either sign up or log in to your account.
          </p>
          <v-row>
            <v-flex>
              <v-btn rounded depressed dark color="blue" @click="$router.push({name: 'SignUp', params: {tag}})">Sign Up</v-btn>
            </v-flex>
            <v-flex>
              <v-btn rounded depressed dark color="orange" @click="$router.push({name: 'Login', params: {tag}})">Login</v-btn>
            </v-flex>
          </v-row>

        </v-card>
        </v-flex>
      </v-layout>

  </v-container>






</template>
<script>
export default {
  name: 'Welcome',
  data() {
    return {
      tag: null

    }
  },
  mounted() {
    if (this.$route.params.tag) {
      this.tag = this.$route.params.tag
      console.log(this.tag)
    }
  }
}
</script>
